import { configureStore } from "@reduxjs/toolkit"
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import persistentReducers from "./persistentReducers";

const persistConfig = {
    key: 'root',
    storage,
    whitelist: ['user', 'precustomer', 'regions']
};

const persistedReducer = persistReducer(persistConfig, persistentReducers);


const initStore = () => {
    let store = configureStore({
      reducer: persistedReducer,
    });
    let persistor = persistStore(store)
    return { store, persistor }
  };

export default initStore();